// extracted by mini-css-extract-plugin
module.exports = {"blurBackground":"Loading_blurBackground__3agjz","textBox":"Loading_textBox__3Q8v2","locallText":"Loading_locallText__2mJ0g","text":"Loading_text__1l1qz"};